import * as React from 'react';
import { createStyles, makeStyles, useTheme} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Card,CardContent } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
        margin: theme.spacing(1),
    },

    iconButton: {
        background: 'none',
        border: 'none',
        padding: 0,
        fontSize: 'inherit',
        cursor: 'pointer',
        color: 'white',
        minWidth: 'auto'
    }
  }),
);

interface IProps {
    icon: IconProp;
    iconSize: SizeProp;
    iconText: string;
    buttonSize?: string | number;
    textFontSize: string;
    adjustLeftIcon: IconProp;
    adjustRightIcon: IconProp;
    arrayItems: string[];
    defaultIndex: number;
};

export const RoomControlAdjustableButton: React.FC<IProps> = ({
    icon,
    iconSize,
    iconText,
    buttonSize,
    textFontSize,
    adjustLeftIcon,
    adjustRightIcon,
    arrayItems,
    defaultIndex,
  }) => {
    const classes = useStyles();
    const theme = useTheme();
    const [currentIndex, setCurrentIndex] = React.useState(defaultIndex);
    
    const defaultTemperature = arrayItems[defaultIndex];
    const [temperature, setTemperature] = React.useState(defaultTemperature);

    const handleAdjustLeft = () => {
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? 0 : prevIndex - 1));
    };
  
    const handleAdjustRight = () => {
      setCurrentIndex((prevIndex) => (prevIndex === arrayItems.length - 1 ? arrayItems.length - 1 : prevIndex + 1));
    };
  
    React.useEffect(()=>{
        setTemperature(arrayItems[currentIndex]);  
    },[currentIndex]);

    return (
      <Card variant="outlined" className={classes.button} style={{ backgroundColor: theme.palette.primary.main, width: buttonSize, height: buttonSize }}>
        <CardContent>
          <div>
            <FontAwesomeIcon icon={icon} size={iconSize} style={{ color: 'white' }} />
          </div>
          <div>
            <Typography variant="body1" align="left" style={{ fontSize: textFontSize, color: 'white', margin: theme.spacing(2) }}>
              {iconText}
            </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
            <Button className={classes.iconButton} onClick={handleAdjustLeft}>
              <FontAwesomeIcon icon={adjustLeftIcon} style={{ color: 'white' }} />
            </Button>
            <div style={{ flex: 1 }}>
            <Typography variant="body2" align="center" style={{ color: 'white'}}>
                {temperature}
            </Typography>
            </div>
            
            <Button className={classes.iconButton} onClick={handleAdjustRight}>
              <FontAwesomeIcon icon={adjustRightIcon} style={{ color: 'white' }} />
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  };